import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Flash = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 13C26 12.45 25.55 12 25 12H18V3C18 2.45 17.55 2 17 2C16.637 2 16.325 2.188 16.15 2.475L6.15 18.475C6.05 18.625 6 18.812 6 19C6 19.55 6.45 20 7 20H14V29C14 29.55 14.45 30 15 30C15.363 30 15.675 29.812 15.85 29.525L25.85 13.525C25.937 13.375 26 13.2 26 13V13ZM16 25.512V19C16 18.45 15.55 18 15 18H8.8L16 6.488V13C16 13.55 16.45 14 17 14H23.2L16 25.512Z" />
	</svg>
);

export default Flash;
